import App from './App.svelte';

const elements = document.querySelectorAll('.product-gallery');

elements.forEach(element => {
	const items = element.querySelectorAll('*[data-type]');
	new App({
		target: element,
		props: {
			items: [...items].map((el, idx) => {
				if(el instanceof HTMLElement) {
					if(el.dataset.type === 'youtube-video') {
						return {
							idx,
							element: null,
							type: el.dataset.type,
							videoToken: el.dataset.videoToken,
							thumbSrc: el.dataset.thumbSrc,
							normalSrc: el.dataset.normalSrc,
							videoActive: false,
							code: `<iframe class="video-container" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/${el.dataset.videoToken}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`
						};
					}
					return {
						idx,
						element: null,
						type: el.dataset.type,
						thumbSrc: el.dataset.thumb1xSrc ?? el.dataset.thumbSrc,
						thumbSrcSet: el.dataset.thumbSrcset ?? null,
						normalSrc: el.dataset.normal1xSrc ?? el.dataset.normalSrc,
						normalSrcSet: el.dataset.normalSrcset ?? null,
						zoomSrc: el.dataset.zoomSrc
					};
				}
			})
		}
	});
});
